import React, { useEffect } from "react";
import EmbedMailComplete from "./EmbedMailComplete.js";
import { useContent } from "../../../../contexts/contentContext/contentContext.js";

import "./EmbedUploader.scss";
import UploaderWrapper from "./FormsUploader/FormsUploaderWrapper.js";
import UploaderProvider from "contexts/uploaderContext/uploaderContext.js";
import { useCookie } from "contexts/cookieContext/cookieContext.js";
import queryString from "query-string";
import { useLocation } from "react-router-dom";
const EmbedUploader = ({
  embedMailId,
  setEmbedMailId,
  setFinishUpload,
  setStartUpload,
  finishUpload,
  formDetails,
  handleFinishUploadProcess,
  buttonsColor,
  backgroundColor,
  hideFooter,
  tidParam,
  isInsideIframe,
  setReSendMail,
}) => {
  const location = useLocation();
  const { setCookies, getCookie, removeCookies } = useCookie();
  const { getPageText, getTextByKey } = useContent();
  useEffect(() => {
    if (finishUpload.exitCode === "ok") {
      document.title = getTextByKey("default-browser-title-embedpage");
      if (handleFinishUploadProcess) {
        handleFinishUploadProcess(true);
      }
    }
  }, [finishUpload, getPageText]);

  const embedDesign = {
    backgroundColor: backgroundColor ? backgroundColor : "#fff",
    buttonsColor: buttonsColor
      ? buttonsColor.includes("#")
        ? buttonsColor
        : "#" + buttonsColor
      : "#15b4d4",
  };

  useEffect(() => {
    if (embedMailId) {
      const isPickerMail = formDetails.IsPickerForm;
      if (isPickerMail) {
        const searchParams = queryString.parse(location.search);
        //if the form is picker
        const tidParam = searchParams["tid"];
        const cookieName = `JMPicker-${tidParam}`;
        //check if exists cookie and if exists, remove it
        if (getCookie(cookieName)) {
          removeCookies(cookieName);
        }
        //set cookie `JMPicker-{encryptedPickerMail}` and value is "UPLOADING" for 24 hours with domain .jumbomail.me
        setCookies(cookieName, "CREATED", {
          path: "/",
          domain: ".jumbomail.me",
          expires: new Date(new Date().getTime() + 24 * 60 * 60 * 1000),
        });
      }
    }
  }, [embedMailId]);

  return (
    <div
      className={`embed-uploader ${hideFooter ? "hide-footers" : ""} ${
        isInsideIframe ? "external-iframe-container" : ""
      }`}
    >
      {embedMailId ? (
        !finishUpload ? (
          <UploaderProvider>
            <UploaderWrapper
              mailId={embedMailId}
              setFinishUpload={setFinishUpload}
              embedDesign={embedDesign}
            />
          </UploaderProvider>
        ) : (
          <EmbedMailComplete
            setEmbedMailId={setEmbedMailId}
            buttonsColor={buttonsColor}
            setStartUpload={setStartUpload}
            setFinishUpload={setFinishUpload}
            finishUpload={finishUpload}
            embedFormDetails={formDetails}
            embedMailId={embedMailId}
            tidParam={tidParam}
            setReSendMail={setReSendMail}
          />
        )
      ) : null}
    </div>
  );
};

export default EmbedUploader;
